import React from 'react';
import { Formik, Form } from 'formik';
import Modal from '../Modal';
import { Button, TextInput } from 'shared';
import CheckTick from '../../../../assets/check_tick.svg';
import './AuthorizeEmailModal.scss';

interface AuthorizeEmailModalProps {
  open: boolean;
  onSubmit: (email: string) => void;
  onClose: () => void;
}

interface FormValues {
  email: string;
}

const AuthorizeEmailModal: React.FC<AuthorizeEmailModalProps> = ({
  open,
  onSubmit,
  onClose,
}) => {
  const initialValues: FormValues = {
    email: '',
  };

  const validate = (values: FormValues) => {
    const errors: Partial<Record<keyof FormValues, string>> = {};

    if (!values.email.trim()) {
      errors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
      errors.email = 'Please enter a valid email address';
    }

    return errors;
  };

  const handleFormSubmit = (values: FormValues, { resetForm }: any) => {
    onSubmit(values.email);
    resetForm();
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeButton={true}
      size="sm"
      overflow={false}
      className="authorize-email-modal"
      body={
        <div className="authorize-email-modal__content">
          <div className="authorize-email-modal__icon">
            <img src={CheckTick} alt="Success" />
          </div>

          <h3 className="authorize-email-modal__title">Application Access</h3>

          <ul className="authorize-email-modal__permissions">
            <li>Manage all notification configuration</li>
            <li>Create and modify booking reservations</li>
            <li>Perform action on folios</li>
            <li>Read folios, including charges and payments</li>
            <li>Modify, check in/out, cancel reservations</li>
            <li>Read reservations</li>
            <li>Retrieve availability information</li>
            <li>Request offers</li>
            <li>Read rates and restrictions</li>
            <li>The scope allows the app to read settings and configurations for the whole account and all properties, including reading units, unit groups, rate plans.</li>
          </ul>

          <Formik
            initialValues={initialValues}
            validate={validate}
            onSubmit={handleFormSubmit}
            enableReinitialize
          >
            {(formik) => (
              <Form>
                <div className="authorize-email-modal__email-section">
                  <p className="authorize-email-modal__email-text">
                    Please enter your email address below. This email address will be used to identify you when onboarding onto the HotelTrader system.
                  </p>

                  <div className="authorize-email-modal__field">
                    <TextInput
                      formik={formik}
                      name="email"
                      dataType="email"
                      placeholder="E-mail address"
                    />
                    {formik.touched.email && formik.errors.email && (
                      <span className="authorize-email-modal__error">{formik.errors.email}</span>
                    )}
                  </div>
                </div>

                <Button
                  appearance="primary"
                  block
                  type="submit"
                >
                  Authorize
                </Button>
              </Form>
            )}
          </Formik>
        </div>
      }
    />
  );
};

export default AuthorizeEmailModal;
